import t from "../helpers/t";
import React from "react";

type TimeInputProps = {
    name: string,
    label: string,
    unit: string,
    value: string|null,
    onChange: (value: number, name: string) => void,
    big: boolean
}
const TimeInput = ({name,label,unit,onChange, value, big} : TimeInputProps) => {
    const onChanges = (e:object) => {
        let val = 0;
        // @ts-ignore
        const units = document.getElementById(name + "_input_unit").value;
        // @ts-ignore
        let count = document.getElementById(name + "_input_count").value;
        if (isNaN(Number(count))) {
            count = 0;
        }
        if (units === 'minutes') {
            val = (unit === 'minutes') ? Number(count) : Number(count) * 60;
        }
        if (units === 'hours') {
            val = (unit === 'minutes') ? Number(count) * 60 : Number(count) * 3600;
        }
        if (units === 'days') {
            val = (unit === 'minutes') ? Number(count) * 60 * 24 : Number(count) * 3600 * 24;
        }
        if (units === 'weeks') {
            val = (unit === 'minutes') ? Number(count) * 60 * 24 * 7 : Number(count) * 3600 * 24 * 7;
        }if (units === 'months') {
            val = (unit === 'months') ? Number(count) * 60 * 24 * 30 : Number(count) * 3600 * 24 * 30;
        }
        if (units === 'years') {
            val = (unit === 'years') ? Number(count) * 60 * 24 * 365 : Number(count) * 3600 * 24 * 365;
        }
        onChange(val, name);

    };

    const getUnit: (time: number, big: boolean) => (string) = (time:number, big:boolean) => {

        if(time === 0 || time === null){
            return 'minutes';
        }
        if (unit === 'seconds') {
            // value in seconds
            if(big){
                if(time % 31536000 === 0) return 'years'

                if(time % 2592000 === 0) return 'months'

                if (time % 604800 === 0) return 'weeks';
            }

            if (time % 86400 === 0) return 'days';

            if (time % 3600 === 0) return 'hours';



            return 'minutes';
        }
        if (unit === 'minutes') {
            // value in minutes
            if(big){
                if(time % 525600 === 0) return 'years'

                if(time % 43200 === 0) return 'months'

                if (time % 10080 === 0) return 'weeks';
            }

            if (time % 1440 === 0) return 'days';

            if (time % 60 === 0) return 'hours';

            return 'minutes';
        }
        return "minutes";
    };

    const getCount: (time: (string | null), big: boolean) => (number | string) = (time:string|null, big:boolean) => {

        if (time !== null) {
            let nTime = parseInt(time);
            const units = getUnit(nTime, big);

            // minutes
            if (units === "minutes" && unit === 'seconds') return parseInt((nTime / 60).toString());
            if (units === "minutes" && unit === 'minutes') return nTime;

            // hours
            if (units === "hours" && unit === 'seconds') return parseInt((nTime / 3600).toString());
            if (units === "hours" && unit === 'minutes') return parseInt((nTime / 60).toString());

            // days
            if (units === "days" && unit === 'seconds') return parseInt((nTime / 86400).toString());
            if (units === "days" && unit === 'minutes') return parseInt((nTime / 1440).toString());

            if(big){
                // weeks
                if (units === "weeks" && unit === 'seconds') return parseInt((nTime / 604800).toString());
                if (units === "weeks" && unit === 'minutes') return parseInt((nTime / 10080).toString());

                // months
                if (units === "months" && unit === 'seconds') return parseInt((nTime / 2592000).toString());
                if (units === "months" && unit === 'minutes') return parseInt((nTime / 43200).toString());

                // years
                if (units === "years" && unit === 'seconds') return parseInt((nTime / 31536000).toString());
                if (units === "years" && unit === 'minutes') return parseInt((nTime / 525600).toString());
            }
            return unit === 'seconds'?parseInt((nTime / 86400).toString()):parseInt((nTime / 1440).toString());
        }
        return "";
    };

    return (
        <>
            <div className="inb-form-group float-left width100">
                <label className="inb-form__controlLabel" style={{minWidth:'45%',float:'left'}}>{label}</label>
                <div className="inb-form-group column medium-1 small-12" style={{float: "left",minWidth:"50%"}}>{/*
                    <label className="inb-form__controlLabel">{t('count_units',null,'capital')}</label>*/}
                    <div className="inb-form__controllClass float-left">
                        <input id={name + "_input_count"} type="text" className="form-control" name="minBookingDuration_count"
                               autoComplete="false" value={getCount(value, big)} style={{border:"1px solid",maxWidth:"50px"}}
                               onChange={(e) => onChanges(e)}/>
                    </div>
                    <div className="inb-form__controllClass float-left">
                        <select id={name + "_input_unit"} className="form-control" name="_unit"
                                value={value===null?getUnit(0, big):getUnit(parseInt(value), big)}
                                onChange={(e) => onChanges(e)} >
                            <option value="minutes">{t('minutes')}</option>
                            <option value="hours">{t('hours')}</option>
                            <option value="days">{t('days')}</option>
                            {big && <>
                                <option value="weeks">{t('weeks')}</option>
                                <option value="months">{t('months')}</option>
                                <option value="years">{t('years')}</option>
                            </>}
                        </select>
                    </div>
                </div>
    {/*        <div className="inb-form-group column medium-4 small-12" style={{float: "left"}}>
                <label className="inb-form__controlLabel">{t('units')}</label>

            </div>*/}
            </div>
        </>
    )
}

export default TimeInput;